import { z } from 'zod';
import { isoDate } from './common';

/** A counterparty: somebody you have been in a meeting with, and where you stand. */
export const person = z.object({
  email: z.string(),
  /** Their account's name, else the name Recall heard them under, else null. */
  name: z.string().nullable(),
  /** The company domain; null for a personal address. */
  company: z.string().nullable(),
  meetingCount: z.number().int(),
  lastMetAt: isoDate,
  /** Open commitments between you, from meetings you were both in. */
  balance: z.object({ iOwe: z.number().int(), theyOwe: z.number().int() }),
});
export type Person = z.infer<typeof person>;
